import {
  faCalendarDay,
  faCalendarWeek,
  faCalendar,
  faCalendarAlt,
  faStore,
  faUsers,
  faUserGroup,
  faChartLine,
  faArrowRight,
} from '@fortawesome/free-solid-svg-icons';

export const ICONS = {
  calendarDay: faCalendarDay,
  calendarWeek: faCalendarWeek,
  calendar: faCalendar,
  calendarAlt: faCalendarAlt,
  store: faStore,
  users: faUsers,
  userGroup: faUserGroup,
  chartLine: faChartLine,
  arrowRight: faArrowRight,
};

export const REPORT_CARDS = [
  {
    id: 'dailyReports',
    title: 'Daily Reports',
    subtitle: 'Sales & Performance',
    icon: ICONS.calendarDay,
    route: '/reports/daily-reports',
  },
  {
    id: 'weeklyReports',
    title: 'Weekly Reports',
    subtitle: 'Weekly Analysis',
    icon: ICONS.calendarWeek,
    route: '/reports/weekly-reports',
  },
  {
    id: 'monthlyReports',
    title: 'Monthly Reports',
    subtitle: 'Monthly Analysis',
    icon: ICONS.calendar,
    route: '/reports/monthly-reports',
  },
  {
    id: 'customRangeReports',
    title: 'Custom Range Reports',
    subtitle: 'Flexible Analysis',
    icon: ICONS.calendarAlt,
    route: '/reports/custom-range-reports',
  },
  {
    id: 'shopPerformance',
    title: 'Shop Performance',
    subtitle: 'Detailed overview',
    icon: ICONS.store,
    hasDetails: true,
  },
  {
    id: 'staffPerformance',
    title: 'Staff Performance',
    subtitle: 'Detailed overview',
    icon: ICONS.users,
    hasDetails: true,
  },
  {
    id: 'customerInsights',
    title: 'Customer Insights',
    subtitle: 'Detailed overview',
    icon: ICONS.userGroup,
    hasDetails: true,
  },
  {
    id: 'financialReports',
    title: 'Financial Reports',
    subtitle: 'Detailed overview',
    icon: ICONS.chartLine,
    hasDetails: true,
  },
] as const;

export const DETAIL_MESSAGES = {
  shopPerformance: {
    title: 'Shop Performance Details',
    description: 'Detailed report on shop performance metrics, sales trends, and operational efficiency.',
  },
  staffPerformance: {
    title: 'Staff Performance Details',
    description: 'Detailed report on staff performance, productivity metrics, and individual contributions.',
  },
  customerInsights: {
    title: 'Customer Insights Details',
    description: 'Detailed report on customer behavior, preferences, and engagement patterns.',
  },
  financialReports: {
    title: 'Financial Reports Details',
    description: 'Detailed report on financial metrics, revenue analysis, and cost breakdowns.',
  },
};
